import { STATION_OPTIONS } from "./resolveStation";

export default function StationSelect({ value, onChange }) {
  return (
    <div className="xoso-sidebar-stations" role="tablist" aria-label="Chọn đài">
      {STATION_OPTIONS.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={`xoso-sidebar-stations__btn${active ? " is-active" : ""}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
